import React, { useState } from 'react';
import { Accordion, AccordionTitle, AccordionContent, Typography } from '@hpstellar/core';

import { Helpers } from '../../../core/src/helpers';
import withPageComponents from '../../../page/components/with-page-components';

import './faq.less';

const FAQ = ({ answer, question, defaultExpanded }) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    return (
        <Accordion expanded={expanded} onChange={setExpanded} size={'small'} defaultExpanded>
            <>
                <AccordionTitle id="accordionHeader" aria-controls="accordionContent" title={question} />
                <AccordionContent>
                    <div className={'faq-content cust-html'} dangerouslySetInnerHTML={Helpers.createMarkup(answer)} />
                </AccordionContent>
            </>
        </Accordion>
    );
};

export default withPageComponents(
    ({ faqSection }) => {
        const { faq, title = 'FAQs' } = faqSection || {};
        if (!faq || faq.length < 1) return null;
        return (
            <div className="faq-section">
                <Typography className="faq-title" tag="h3" variant="titleM">
                    {title}
                </Typography>
                {faq.map((faqItem, index) => (
                    <FAQ key={faqItem.question || index} {...faqItem} defaultExpanded={false} />
                ))}
            </div>
        );
    },
    { components: ['faqSection'] }
);
